import placeholder from "../assets/imageplaceholder.svg";

const productStatus = {
  NS_PRODUCT_RELEASED_FOR_SALE: "RELEASED_FOR_SALE",
  NS_PRODUCT_NOT_RELEASED_FOR_SALE: "NOT_RELEASED_FOR_SALE",
  NS_PRODUCT_STOP_STATUS: "STOP_STATUS",
  NS_PRODUCT_NOT_SOLD_SEPARATELY: "NOT_SOLD_SEPERATELY",
  NS_PRODUCT_DISCONTINUED: "DISCONTINUED",
  NS_PRODUCT_NOT_FOUND: "NOT_FOUND"
};

/**
 * Model object for product
 */
export default class Product {
  /**
   * Copnstructor
   * @param {string} id
   * @param {json} productData product data object
   */
  constructor(id, productData) {
    this._id = id;
    Object.assign(this, productData);
    this.initProductImage();
  }

  /**
   * Init function
   * @return {void}
   */
  initProductImage() {
    let image;
    const variantWithImage = this.getFirstVariantWithImage();
    if (this.hasVariants() && variantWithImage) {
      image = variantWithImage.productImages[0];
    } else if (this.hasProductImage()) {
      image = this.productImages[0];
    } else {
      image = { url: placeholder, alt: "placeholder" };
    }

    this.carouselImage = image;
  }

  /**
   * Gets the first variant with an image
   * @return {any} Variant object
   */
  getFirstVariantWithImage() {
    // First, attempt to find a variant that matches this product's internal ID
    const matchingVariant = this.variants.find(
      variant =>
        variant.sku === this._id &&
        variant.productImages &&
        variant.productImages.length
    );

    if (matchingVariant) return matchingVariant;

    return this.variants.find(
      variant => variant.productImages && variant.productImages.length
    );
  }

  get fullTitle() {
    const baseSegment = this.title;
    const variant = this.firstVariant;

    let variantSegment = "";

    if (variant && variant.variantLabel) {
      variantSegment = " – " + variant.variantLabel;
    }

    return baseSegment + variantSegment;
  }

  /**
   * Getter for the first product variant
   */
  get firstVariant() {
    // First, attempt to find a variant that matches this product's internal ID
    const matchingVariant = this.variants.find(v => v.sku === this._id);

    if (matchingVariant) return matchingVariant;

    return this.variants.length > 0 && this.variants[0];
  }

  /**
   * Getter for the first product variant's primaryBrand
   */
  get primaryBrand() {
    return this.firstVariant && this.firstVariant.primaryBrand;
  }

  /**
   * Checks if product has a variant
   * @return {boolean}
   */
  hasVariants() {
    return this.variants && this.variants.length > 0;
  }

  /**
   * Checks if product has an image
   * @return {boolean}
   */
  hasProductImage() {
    return this.productImages && this.productImages.length > 0;
  }

  /**
   * Checks if product is not available for sale
   * @return {boolean}
   */
  isNotReleasedForSale() {
    return (
      this.hasVariants() &&
      this.firstVariant.status.retail ==
        productStatus.NS_PRODUCT_NOT_RELEASED_FOR_SALE
    );
  }

  /**
   * Checks if product is exclusive
   * @return {boolean}
   */
  isExclusive() {
    return this.hasVariants() && this.firstVariant.isExclusive;
  }

  /**
   * Checks if product is out of stock
   * @return {boolean}
   */
  isOutOfStock() {
    return this.hasVariants() && this.firstVariant.availableQuantity < 1;
  }
}
